import React, { Component } from "react";
import { Table, Input, Select, Divider } from 'antd';
import PropTypes from 'prop-types';
import style from '../index.css';

const { TextArea } = Input;
const Option = Select.Option;

/**
 * 步骤三配置环节关系
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-09 10:05:35
 * Version: 1.0
 * Modify log:
 */
class ThirdStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            hjgxData: [], //配置的环节信息数据
            ylhjSelectOption: [] //依赖环节下拉数据
        }
        this.cacheData = this.state.hjgxData.map(item => ({ ...item })); //缓存编辑环节信息数据
    }

    //初始化数据
    componentDidMount() {

        const { data } = this.props;

        if (data) {

            const newData = [...data];
            for (let key in newData) {
                newData[key].editable = false;
            }

            this.setState({ hjgxData: newData });

            const ylhjSelectOption = this.state.ylhjSelectOption; //依赖环节选项

            for (let key in data) {
                let option = (<Option key={data[key].pkid} value={data[key].pkid}>{data[key].hjmc}</Option>);
                ylhjSelectOption.push(option);
            }
            this.setState({ ylhjSelectOption: ylhjSelectOption });
        }

    }

    //编辑环节信息
    edit = (pkid) => {
        const newData = [...this.state.hjgxData];
        const target = newData.filter(item => pkid === item.pkid)[0];
        if (target) {
            target.editable = true;
            this.setState({ hjgxData: newData });
        }
    }

    //保存编辑的环节信息
    save = (pkid) => {
        const newData = [...this.state.hjgxData];
        const target = newData.filter(item => pkid === item.pkid)[0];
        if (target) {
            delete target.editable;
            this.props.onChange(newData);
            this.setState({ hjgxData: newData });
            this.cacheData = newData.map(item => ({ ...item }));
        }
    }

    //取消编辑环节信息
    cancel = (pkid) => {
        const newData = [...this.state.hjgxData];
        const target = newData.filter(item => pkid === item.pkid)[0];
        if (target) {

            let cache = this.cacheData.filter(item => {
                if (item) {
                    return pkid === item.pkid
                }
            })[0];

            delete target.editable;

            if (cache) {

                //如果是点击取消时，如果缓存数据里有，则获取缓存数据
                Object.assign(target, cache);
                this.setState({ hjgxData: newData });

            } else {

                //如果是点击取消时，缓存数据里没有找到，则还原为原始数据状态
                delete target.yllchjid;
                delete target.yllchjmc;
                delete target.hjblts;
                this.setState({ hjgxData: newData });
            }
        }
    }

    //表格单元格编辑时回调
    handleEditableCellChange = (value, pkid, column) => {
        const newData = [...this.state.hjgxData];
        const target = newData.filter(item => pkid === item.pkid)[0];
        if (target) {
            target[column] = value;
            this.setState({ hjgxData: newData });
        }
    }

    render() {

        const { ylhjSelectOption } = this.state;

        const columns = [
            {
                title: '步骤',
                key: 'bz',
                dataIndex: 'bz',
                width: '60px',
            }, {
                title: '环节名称',
                key: 'hjmc',
                dataIndex: 'hjmc',
                width: '120px',
            }, {
                title: '依赖环节',
                key: 'yllchjmc',
                dataIndex: 'yllchjmc',
                width: '120px',
                render: (text, record, index) => {
                    const editable = record.editable;
                    const filterOption = ylhjSelectOption.filter((item, i) => i != index);
                    return (
                        editable ?
                            <Select style={{ margin: '-5px 0', width: '100%' }} value={record.yllchjid}
                                mode="multiple" placeholder="请选择依赖环节"
                                onChange={(value, option) => {
                                    const yllchjmcArray = [];
                                    for (let key in option) {
                                        yllchjmcArray.push(option[key].props.children);
                                    }
                                    this.handleEditableCellChange(value, record.pkid, 'yllchjid');
                                    this.handleEditableCellChange(yllchjmcArray, record.pkid, 'yllchjmc');
                                }}
                                onDeselect={(value, option) => {
                                    const newData = [...this.state.hjgxData];
                                    const target = newData.filter(item => record.pkid === item.pkid)[0];
                                    if (target) {
                                        const yllchjidArray = target.yllchjid;
                                        const yllchjmcArray = target.yllchjmc;
                                        const yllchjidTarget = yllchjidArray.filter(item => value !== item);
                                        const yllchjmcTarget = yllchjmcArray.filter(item => option.props.children !== item);
                                        this.handleEditableCellChange(yllchjidTarget, record.pkid, 'yllchjid');
                                        this.handleEditableCellChange(yllchjmcTarget, record.pkid, 'yllchjmc');
                                    }
                                }}>
                                {filterOption}
                            </Select>
                            : text ? text.toString() : null
                    );
                },
            }, {
                title: '环节办理提示',
                key: 'hjblts',
                dataIndex: 'hjblts',
                width: '150px',
                render: (text, record) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <TextArea style={{ margin: '-5px 0' }} rows={2}
                                onChange={e => this.handleEditableCellChange(e.target.value, record.pkid, 'hjblts')} />
                            : text
                    );
                },
            }, {
                title: '操作',
                key: 'operation',
                dataIndex: 'operation',
                width: '80px',
                render: (text, record) => {
                    const { editable } = record;
                    return (
                        <div className={style["editable-row-operations"]}>
                            {
                                editable ?
                                    <span>
                                        <a style={{ margin: 0 }} onClick={() => this.save(record.pkid)}>保存</a>
                                        <Divider type={'vertical'} />
                                        <a onClick={() => this.cancel(record.pkid)}>取消</a>
                                    </span>
                                    : <span>
                                        <a style={{ margin: 0 }} onClick={() => this.edit(record.pkid)}>编辑</a>
                                    </span>
                            }
                        </div>
                    );
                },
            }
        ];

        return (
            <div>
                <Table dataSource={this.state.hjgxData} columns={columns} pagination={false} />
            </div>
        )
    }
}

ThirdStep.propTypes = {
    data: PropTypes.array, //步骤二的缓存数据
    onChange: PropTypes.func //环节配置信息改变时回调
}

export default ThirdStep;


// WEBPACK FOOTER //
// ./components/lcgl/lcpz/edit-form/step-third.js